import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { DocumentTextIcon } from '../../../../components/ui/Icons';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardContent, 
  Badge 
} from '../../../../components/ui';

const ApprovalTemplateDetails = ({ selectedRecord }) => {
  const { theme } = useTheme();

  return (
    <>
      {/* Description */}
      {selectedRecord.description && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center">
              <DocumentTextIcon className="w-4 h-4 mr-2" />
              Description
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className={cn("text-sm leading-relaxed", theme.text.primary)}>
              {selectedRecord.description}
            </p>
          </CardContent>
        </Card>
      )}

      {/* Template Configuration */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center">
            <DocumentTextIcon className="w-4 h-4 mr-2" />
            Template Configuration
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex items-center justify-between py-2 border-b">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Approval Type</span>
              <Badge variant="outline">
                {selectedRecord.approvalType?.charAt(0).toUpperCase() + selectedRecord.approvalType?.replace('_', ' ')?.slice(1)}
              </Badge>
            </div>
            {selectedRecord.workflowType && (
              <div className="flex items-center justify-between py-2 border-b">
                <span className={cn("text-sm font-medium", theme.text.secondary)}>Workflow Type</span>
                <Badge variant="outline">
                  {selectedRecord.workflowType === 'review' ? 'Review Only' :
                   selectedRecord.workflowType === 'approval' ? 'Approval Only' :
                   selectedRecord.workflowType === 'review_approval' ? 'Review & Approval' :
                   'Standard'}
                </Badge>
              </div>
            )}
            {selectedRecord.entityType && (
              <div className="flex items-center justify-between py-2 border-b">
                <span className={cn("text-sm font-medium", theme.text.secondary)}>Entity Type</span>
                <Badge variant="outline">
                  {selectedRecord.entityType?.name?.charAt(0).toUpperCase() + selectedRecord.entityType?.name?.slice(1)}
                </Badge>
              </div>
            )}
            {selectedRecord.priority && (
              <div className="flex items-center justify-between py-2">
                <span className={cn("text-sm font-medium", theme.text.secondary)}>Default Priority</span>
                <Badge variant="outline">
                  {(selectedRecord.priority?.name || selectedRecord.priority)?.charAt(0).toUpperCase() + (selectedRecord.priority?.name || selectedRecord.priority)?.slice(1)}
                </Badge>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default ApprovalTemplateDetails;

